<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,
body {
  height: 100%;
  padding: 0;
  margin: 0;
}

#app {
  height: 100%;
  padding: 0;
  margin: 0;
  /* text-align: center;
  color: #2c3e50; */
  /* margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue